import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Css/ExamCreateForm.css";
import API_BASE from "../config/api";

  const API_BASE_URL = `${API_BASE}`;

const createEmptySubtopic = () => ({
    subtopic: "",
    maxMarks: "",
    maxQuestions: "",
    selectionMode: 1
});

const createEmptyTopic = () => ({
    subjectId: "",
    topic: "",
    topicQuestionCount: "",
    subtopics: [createEmptySubtopic()],
    topicOptions: [],
    subtopicOptions: [],
});

export default function BlueprintPage() {

    const [blueprints, setBlueprints] = useState([]);
    const [softwares, setSoftwares] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [selectedStandardId, setSelectedStandardId] = useState(null);
    const [papers, setPapers] = useState([]);

    const [form, setForm] = useState({
        softwareId: "",
        name: "",
        paperNumber: "",
        topics: [createEmptyTopic()]
    });

    const headers = {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
    };

    /* ---------------- LOAD INITIAL ---------------- */

    useEffect(() => {
        loadBlueprints();
        loadSoftwares();
    }, []);

    const loadBlueprints = async () => {
        const res = await axios.get(API_BASE_URL, { headers });
        setBlueprints(res.data);
    };

    /* ---------------- SOFTWARE LOAD ---------------- */

    const loadSoftwares = async () => {
        const res = await axios.get(`${API_BASE_URL}/all-softwares`, { headers });
        setSoftwares(res.data);
    };

    const loadPapers = async (softwareId) => {
        const res = await axios.get(
            `${API_BASE_URL}/api/softwares/${softwareId}`,
            { headers }
        );

        setPapers(res.data.papers || []);
    };

    const loadSubjects = async (softwareId, paperNumber) => {
        if (!softwareId || !paperNumber) return;

        const res = await axios.get(
            `${API_BASE_URL}/paper-subjects?softwareId=${softwareId}&paperNumber=${paperNumber}`,
            { headers }
        );

        setSubjects(res.data);
    };

    const loadStandardFromSoftware = async (softwareId) => {
        const res = await axios.get(`${API_BASE_URL}/software-standard?softwareId=${softwareId}`, { headers });
        if (res.data) {
            await loadSubjects(res.data.standardId);
        }
    };

    /* ---------------- FORM CHANGE ---------------- */

    const handleChange = async (field, value) => {

        const updatedForm = { ...form, [field]: value };
        setForm(updatedForm);

        if (field === "softwareId") {

            const selected = softwares.find(x => x.id == value);

            setSelectedStandardId(selected.standardId);

            await loadPapers(value);

            setSubjects([]);
        }

        if (field === "paperNumber") {
            await loadSubjects(updatedForm.softwareId, value);
        }
    };

    /* ---------------- TOPIC CHANGE ---------------- */

    const handleTopicChange = async (i, field, value) => {
        const updated = [...form.topics];
        updated[i][field] = value;

        const topic = updated[i];

        if (field === "subjectId") {

            const res = await axios.get(
                `${API_BASE_URL}/paper-topics?subjectId=${value}`,
                { headers }
            );

            topic.topicOptions = res.data;
            topic.topic = "";
            topic.subtopics = [createEmptySubtopic()];
        }

        if (field === "topic") {

            const selectedTopic = topic.topicOptions.find(x => x.name === value);
            if (!selectedTopic) return;

            const res = await axios.get(
                `${API_BASE_URL}/paper-subtopics?topicId=${selectedTopic.id}`,
                { headers }
            );

            topic.subtopicOptions = res.data;
        }

        setForm({ ...form, topics: updated });
    };

    /* ---------------- SUBTOPIC CHANGE ---------------- */

    const handleSubtopicChange = (tIndex, sIndex, field, value) => {
        const updated = [...form.topics];
        updated[tIndex].subtopics[sIndex][field] = value;
        setForm({ ...form, topics: updated });
    };

    /* ---------------- ADD REMOVE ---------------- */

    const addTopic = () =>
        setForm({ ...form, topics: [...form.topics, createEmptyTopic()] });

    const removeTopic = (index) => {
        const updated = [...form.topics];
        updated.splice(index, 1);
        setForm({ ...form, topics: updated });
    };

    const addSubtopic = (tIndex) => {
        const updated = [...form.topics];
        updated[tIndex].subtopics.push(createEmptySubtopic());
        setForm({ ...form, topics: updated });
    };

    const removeSubtopic = (tIndex, sIndex) => {
        const updated = [...form.topics];
        updated[tIndex].subtopics.splice(sIndex, 1);
        setForm({ ...form, topics: updated });
    };

    /* ---------------- CREATE ---------------- */

    const createBlueprint = async () => {
        const payload = {
            softwareId: Number(form.softwareId),
            name: form.name,
            paperNumber: form.paperNumber ? Number(form.paperNumber) : null,
            topics: form.topics.map(t => ({
                subjectId: Number(t.subjectId),
                unitNo: Number(t.unitNo),
                topic: t.topic,
                topicQuestionCount: Number(t.topicQuestionCount),
                subtopics: t.subtopics.map(s => ({
                    subUnitNo: Number(s.subUnitNo),
                    subtopic: s.subtopic,
                    maxMarks: Number(s.maxMarks),
                    maxQuestions: Number(s.maxQuestions),
                    selectionMode: Number(s.selectionMode)
                }))
            }))
        };

        await axios.post(API_BASE_URL, payload, { headers });

        alert("Blueprint Created");
        loadBlueprints();

        setForm({
            softwareId: "",
            name: "",
            paperNumber: "",
            topics: [createEmptyTopic()]
        });
    };

    /* ---------------- DELETE ---------------- */

    const deleteBlueprint = async (id) => {
        if (!window.confirm("Delete blueprint?")) return;
        await axios.delete(`${API_BASE_URL}/${id}`, { headers });
        loadBlueprints();
    };

    /* ---------------- UI ---------------- */

    return (
        <div className="create-exam-wrapper">
            <div className="create-exam-form">
                <h2>Create Blueprint</h2>

                <div className="form-grid">

                    {/* SOFTWARE */}
                    <div className="form-group">
                        <label>Software</label>
                        <select
                            value={form.softwareId}
                            onChange={e => handleChange("softwareId", e.target.value)}
                        >
                            <option value="">Select Software</option>
                            {softwares.map(s =>
                                <option key={s.id} value={s.id}>{s.softwareName}</option>
                            )}
                        </select>

                        <div className="form-group">
                            <label>Standard</label>
                            <input
                                value={softwares.find(x => x.id == form.softwareId)?.standardName || ""}
                                disabled
                            />
                        </div>
                    </div>

                    {/* NAME */}
                    <div className="form-group">
                        <label>Name</label>
                        <input value={form.name}
                            onChange={e => handleChange("name", e.target.value)} />
                    </div>

                    {/* PAPER */}
                    <div className="form-group">
                        <label>Paper Number</label>
                        <select
                            value={form.paperNumber}
                            onChange={e => handleChange("paperNumber", e.target.value)}
                        >
                            <option value="">Select Paper</option>

                            {papers.map(p => (
                                <option key={p.paperNumber} value={p.paperNumber}>
                                    Paper {p.paperNumber}
                                </option>
                            ))}

                        </select>
                    </div>
                </div>

                {/* TOPICS */}
                {form.topics.map((topic, ti) => (
                    <div key={ti} style={{ marginTop: 30 }}>

                        <h3>Topic {ti + 1}</h3>

                        <div className="form-grid">

                            {/* SUBJECT */}
                            <div className="form-group">
                                <label>Subject</label>
                                <select
                                    value={topic.subjectId}
                                    onChange={e => handleTopicChange(ti, "subjectId", e.target.value)}
                                >
                                    <option value="">Select</option>
                                    {subjects.map(s =>
                                        <option key={s.id} value={s.id}>{s.name}</option>
                                    )}
                                </select>
                            </div>

                            {/* UNIT */}
                            <div className="form-group">
                                <label>Unit</label>
                                <input value={topic.unitNo}
                                    onChange={e => handleTopicChange(ti, "unitNo", e.target.value)} />
                            </div>

                            {/* TOPIC */}
                            <div className="form-group">
                                <label>Topic</label>
                                <select
                                    value={topic.topic}
                                    onChange={e => handleTopicChange(ti, "topic", e.target.value)}
                                >
                                    <option value="">Select Topic</option>
                                    {topic.topicOptions?.map(t =>
                                        <option key={t.id} value={t.name}>{t.name}</option>
                                    )}
                                </select>
                            </div>

                            {/* COUNT */}
                            <div className="form-group">
                                <label>Question Count</label>
                                <input value={topic.topicQuestionCount}
                                    onChange={e => handleTopicChange(ti, "topicQuestionCount", e.target.value)} />
                            </div>
                        </div>

                        {/* SUBTOPICS */}
                        {topic.subtopics.map((sub, si) => (
                            <div key={si} style={{ marginTop: 20, paddingLeft: 20 }}>

                                <div className="form-grid">

                                    <div className="form-group">
                                        <label>Subtopic</label>
                                        <select
                                            value={sub.subtopic}
                                            onChange={e => handleSubtopicChange(ti, si, "subtopic", e.target.value)}
                                        >
                                            <option value="">Select</option>
                                            {topic.subtopicOptions?.map(s =>
                                                <option key={s.id} value={s.name}>{s.name}</option>
                                            )}
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label>Max Marks</label>
                                        <input value={sub.maxMarks}
                                            onChange={e => handleSubtopicChange(ti, si, "maxMarks", e.target.value)} />
                                    </div>

                                    <div className="form-group">
                                        <label>Max Questions</label>
                                        <input value={sub.maxQuestions}
                                            onChange={e => handleSubtopicChange(ti, si, "maxQuestions", e.target.value)} />
                                    </div>

                                    <div className="form-group">
                                        <label>Selection Mode</label>
                                        <select
                                            value={sub.selectionMode}
                                            onChange={e => handleSubtopicChange(ti, si, "selectionMode", e.target.value)}
                                        >
                                            <option value={1}>Random</option>
                                            <option value={2}>Sequential</option>
                                        </select>
                                    </div>
                                </div>

                                <button className="remove-topic-btn" onClick={() => removeSubtopic(ti, si)}>Remove</button>
                            </div>
                        ))}

                        <div className="add-btn">
                            <button className="add-topic-btn" onClick={() => addSubtopic(ti)}>+ Add Subtopic</button>
                            <button className="remove-topic-btn" onClick={() => removeTopic(ti)}>Remove Topic</button>
                        </div>
                    </div>
                ))}

                <br />
                <button className="add-topic-btn" onClick={addTopic}>+ Add Topic</button>

                <br /><br />
                <button className="exam-popup-btn primary" onClick={createBlueprint}>
                    Create Blueprint
                </button>
            </div>


            <div style={{ marginTop: 50 }}>
                <h2>All Blueprints</h2>

                <div className="table-card">
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Software</th>
                                <th>Paper</th>
                                <th>Status</th>
                                <th>Rules</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {blueprints.length === 0 && (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        No Blueprints Found
                                    </td>
                                </tr>
                            )}

                            {blueprints.map(b => (
                                <tr key={b.id}>
                                    <td>{b.id}</td>
                                    <td>{b.name}</td>
                                    <td>{b.softwareName}</td>
                                    <td>{b.paperNumber || "-"}</td>
                                    <td>
                                        <span className={b.isActive ? "status-active" : "status-inactive"}>
                                            {b.isActive ? "Active" : "Inactive"}
                                        </span>
                                    </td>

                                    {/* Rules preview */}
                                    <td>
                                        {b.rules?.map(r => (
                                            <div key={r.id}>
                                                {r.subjectName} — {r.topic}
                                            </div>
                                        ))}
                                    </td>

                                    <td>
                                        <button
                                            className="remove-topic-btn"
                                            onClick={() => deleteBlueprint(b.id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
}
